import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import Image from '@base/lib/ThemeImage';
import siteConf from 'pro/config/site';
import styles from './index.module.less';
import { useStoreState } from 'base/store';
import { Trans } from 'base/utils/i18n';

type IProps = {
    // props
}


const steps = [
    {
        text: 'web_product_afterpay_step_1',
        imageUrl: 'asset/width-192/picture/f908734c681677191b444e579e2f209f.png'
    },
    {
        text: 'web_product_afterpay_step_2',
        imageUrl: 'asset/width-192/picture/4edef173d1e92a44357fc2b50b141531.png'
    },
    {
        text: 'web_product_afterpay_step_3',
        imageUrl: 'asset/width-192/picture/ec7c27d7a3e250b843b7574a93e8bb04.png'
    },
    {
        text: 'web_product_afterpay_step_4',
        imageUrl: 'asset/width-192/picture/0d165bb5fe7acebeb730ec3e16691974.png'
    },
]

const AfterPaySteps: React.FC<IProps> = (props) => {
    const { ua: { isPhone } } = useStoreState('rootStore');

    return (
        <div className={cn('flex', styles['after-pay-steps'])}>
            {steps.map((sItem, index) => {
                return (
                    <div key={index} className={cn('flex flex-middle', styles.step)}>
                        <div className={cn(styles.img)}>
                            <Image
                                src={sItem.imageUrl}
                                alt={siteConf.brand}
                                width={64}
                                background={false}
                                fixed
                            />
                        </div>

                        <div className={styles.text}>
                            <Trans
                                i18nKey={sItem.text}
                                components={{ br: isPhone ? <br/> : <></> }}
                            />
                        </div>
                    </div>
                )
            })}
        </div>
    );
};

export default AfterPaySteps